import { render } from "./LeaveComment.vue?vue&type=template&id=222b3933&scoped=true"
import script from "./LeaveComment.vue?vue&type=script&lang=js"
export * from "./LeaveComment.vue?vue&type=script&lang=js"

import "./leave-comment.scss?vue&type=style&index=0&id=222b3933&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222b3933"]])

export default __exports__